import { CoverageIdEnum, PolicyProductIdEnum } from 'outshared-lib';
import { CoverageMergeOptionsConfigInterface } from '@app/my-zone/config/coverage-merge-options-config.interface';

export const coverageMergeOptionsConfig: CoverageMergeOptionsConfigInterface = {
    [PolicyProductIdEnum.Car]: {
        match: [CoverageIdEnum.CarRoadsideAssistanceEurope],
        mergeIfMatch: [CoverageIdEnum.CarRoadsideAssistanceNetherlands],
        overrideBy: CoverageIdEnum.CarRoadsideAssistanceEurope
    },
};
